import { API } from "aws-amplify";
import { useContext, useEffect, useState } from "react";
import {
  TouchableOpacity,
  ImageBackground,
  View,
  Text,
  Button,
  Platform,
} from "react-native";
import { FlatList } from "react-native-gesture-handler";
import { BooksContext } from "../globalData/BooksContext";
import { UserContext } from "../globalData/UserContext";
import { deleteBooks } from "../src/graphql/mutations";
import Card from "../styles/Card";
import { globalStyles } from "../styles/globalStyles";
import MyBookInfo from "./MyBookInfo";
import { MaterialIcons } from "@expo/vector-icons";
import Blank from "./components/Blank";

export default function MyBooks() {
  const [mybooks, setMyBooks] = useState([]);
  const [modalOpen, setModalOpen] = useState(false);
  const [item, setItem] = useState({});
  const [requests, setRequests] = useState();
  const userData = useContext(UserContext);
  const booksData = useContext(BooksContext);
  const [instructions, setInstructions] = useState(false);
  const [empty, setEmpty] = useState(false);

  // filters w community and book owner
  function filterBooks() {
    let myBooks;
    if (booksData.books != null) {
      myBooks = booksData.books.filter(
        (book) => book.usersOwnBooksUId == userData.user.data.getUsers.uId
      );
    }
    setMyBooks(myBooks);
    setEmpty(myBooks.length == 0);
  }

  // ensures that books are only retrieved once (no infinite loop)
  useEffect(() => {
    filterBooks();
  }, [booksData.books]);

  // if a user decides to remove a book, the deleteBook mutation is called and
  // the current book that the user has clicked on is deleted.
  async function removeBook() {
    try {
      await API.graphql({
        query: deleteBooks,
        variables: {
          input: {
            bookId: item.bookId,
          },
        },
      });
    } catch (evt) {
      console.log(evt);
    }
  }

  let numColumns;
  if (Platform.OS == "web") numColumns = 3;
  else numColumns = 1;
  return (
    <ImageBackground
      style={globalStyles.container}
      resizeMode="cover"
      source={
        !empty
          ? require("../assets/background.png")
          : require("../assets/blankBackground.png")
      }
    >
      {/* the component that renders the screen that shows up whenever a book is clicked. Passes
      modal options, removeBook and the requests of the current book to the component */}
      <MyBookInfo
        modalOpen={modalOpen}
        setModalOpen={setModalOpen}
        item={item}
        removeBook={async () => {
          await removeBook();
          booksData.refreshBooks();
        }}
        requests={requests}
        refresh={() => {
          booksData.refreshBooks();
        }}
      />
      <View style={{ flexDirection: "row" }}>
        <MaterialIcons
          name="info"
          color="#56494c"
          size={33}
          style={{}}
          onPress={() => {
            setInstructions(true);
          }}
        />
        {instructions && (
          <View style={globalStyles.instructions}>
            <Text style={{ ...globalStyles.paragraph }}>
              This page shows all the books that you own and have added to this
              community (NOT across all communities). Books will be displayed
              below. Click on one to check its status or to remove it.
            </Text>
            <Button
              title="ok "
              onPress={() => {
                setInstructions(false);
              }}
            />
          </View>
        )}
      </View>
      {/* renders each book individually with the Card layout defined in the Card component. Each book
        is pressable and if clicked, the modal containing the MyBookInfo screen is shown and the item
        clicked is updated. the requests of the item are also updates in order to update the info shown
        in MyBooksInfo */}
      {empty && (
        <Blank
          titleText="You have not added any books to your library."
          subtitleText="Head over to Share Books to start uncaging your books!"
          image={0}
        />
      )}

      <FlatList
        numColumns={numColumns}
        data={mybooks}
        renderItem={({ item }) => (
          <TouchableOpacity
            onPress={() => {
              setModalOpen(true);
              setItem(item);
              setRequests(item.requests.items);
            }}
            style={{ flex: 1 }}
          >
            <Card
              uri={item.Image}
              title={item.title}
              authors={item.Author}
              status={item.status}
              user={item.usersBorrowedBooksUId}
              owner={false}
              requests={item.requests.items}
            />
          </TouchableOpacity>
        )}
      />
    </ImageBackground>
  );
}
